<div class="container-fluid "  style="background-color: #d0d0d0">
    <div class="container">
        <div class="row">
            <!-- Login Left -->
            <div class="login-left align-self-center col-xl-5 col-md-6 col-xs-12">
                <div class="primary" *ngIf="!isSubmit">
                    <h3>Forget Password</h3>
                    <p>Enter your email address we’ll email you a link to reset your password.</p>
                    <!-- Form Section -->

                    <form (ngSubmit)="forgotPasswordSubmit()" [formGroup]="form">
                        <div class="form-group">
                            <div class="errorHandler" [ngClass]="{ 'is-invalid': (submitted && f.emailadd.errors) || emailFocus}">
                                <input id="EmailAddress" formControlName="emailadd" type="email" required (focus)="autofocus()" class="form-control" [autofocus]="true">

                                <label for="EmailAddress">Enter Your Email</label>
                            </div>
                            <div *ngIf="submitted && f.emailadd.errors" class="invalid-feedback">
                                <div *ngIf="f.emailadd.errors.required">Email is required</div>
                                <div *ngIf="f.emailadd.errors.email">Email must be a valid email address</div>
                            </div>
                            <div *ngIf="isError !== ''" class="invalid-feedback">
                                  {{isError}}
                            </div>
                        </div>

                        <div class="mt-4 mb-4" *ngIf="needClient">
                            <span>Select Client</span>
                            <div class="errorHandler">
                                <select id="client_id"  class="custom-select form-control" > 
                                    <option value="{{c.client.ID}}"
                                        *ngFor="let c of clients">{{c.client?.ClientName}} 
                                    </option>
                                </select>
                            </div>
                        </div>

                        <button type="submit" class="btn btn-default">Send</button>
                        <a href="javascrpt:void(0);" [routerLink]="['/login']">Wait, I Remember it</a>
                    </form>
                </div>
                <div class="secondary" *ngIf="isSubmit">
                    <h3>We just Emailed you :)</h3>
                    <p>Password reset instructions have been emailed to you. Be sure to check your spam folder.</p>
                    <a [routerLink]="['/resend']" class="">Haven’t received your email?</a>
                </div>

            </div>
            <!-- Login Right -->
            <div class="login-right col-xl-7 col-sm-6 d-none d-md-block  " style="background-image: url('assets/images/minneapolis-skyline.jpg')">
            </div>
        </div>
    </div>
</div>
